class Login {
	constructor() {
		if (this.#isNotOnLoginPage()) return;
		sessionStorage.removeItem("1.0.0@treeview");
		this.#listenToLoginAttempt();
		this.#injectGlobals();
		this.#abortAllOtherLegacyScriptsInitialization();
	}

	#isNotOnLoginPage() {
		const LOGIN_PATH = "/login";
		const currentURL = new URL(location.href);
		const URLPath = currentURL.pathname;
		return URLPath !== LOGIN_PATH;
	}

	#listenToLoginAttempt() {
		const $form = jQuery(".form");
		$form.submit(tryToAuthenticateUserfunction);
		return;
		function tryToAuthenticateUserfunction() {
			const formData = jQuery(this).serializeArray();
			jQuery.ajax({
				type: "POST",
				url: jQuery(this).attr("action"),
				data: formData,
				cache: false,
				success: () => {
					if (typeof Android !== "undefined") Android.setMail(formData[1].value);
					window.location.assign("/");
				},
				error: (val) => {
					if (val.msg) toastr.error(val.msg);
					const errorLines = Object.values(val.responseJSON)
						.map((errorLine) => `<li>${errorLine}</li>`)
						.join("");
					toastr.error(`<ul>${errorLines}</ul>`);
				},
				complete: () => jQuery("#loading").fadeOut("slow", () => jQuery("#loading").css("display", "none")),
				beforeSend: () => jQuery("#loading").css("display", "block"),
			});
			return false;
		}
	}

	#injectGlobals() {
		injectToastError();
		function injectToastError() {
			window.toastError = (msg) => {
				const TOASTR_OPTIONS = {
					closeButton: true,
					progressBar: false,
					debug: false,
					positionClass: "toast-bottom-full-width",
					showDuration: 333,
					hideDuration: 333,
					timeOut: 3000,
					extendedTimeOut: 1000,
					showEasing: "swing",
					hideEasing: "swing",
					showMethod: "slideDown",
					hideMethod: "slideUp",
				};
				toastr.options = TOASTR_OPTIONS;
				toastr.clear();
				toastr.error(msg, "<strong>Whoops!</strong> Houve algum problema!");
			};
		}
	}

	#abortAllOtherLegacyScriptsInitialization() {
		throw new Error("Login page detected! Aborting the other legacy application scripts initialization...");
	}
}

new Login();
